import React, { useEffect } from 'react';

declare global {
  interface Window {
    ChannelIO?: any;
    ChannelIOInitialized?: boolean;
  }
}

const ChannelIOWidget: React.FC = () => {
  useEffect(() => {
    // ChannelIO boot script
    const initializeChannelIO = () => {
      const w = window;
      if (w.ChannelIO) {
        return console.error("ChannelIO script included twice.");
      }
      const ch: any = (...args: any[]) => {
        ch.q.push(args);
      };
      ch.q = [];
      ch.c = (args: any) => {
        ch.q.push(args);
      };
      w.ChannelIO = ch;

      const loadScript = () => {
        if (w.ChannelIOInitialized) {
          return;
        }
        w.ChannelIOInitialized = true;
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
        const x = document.getElementsByTagName("script")[0];
        x.parentNode?.insertBefore(s, x);
      };

      if (document.readyState === "complete") {
        loadScript();
      } else {
        w.addEventListener("DOMContentLoaded", loadScript);
        w.addEventListener("load", loadScript);
      }
    };

    initializeChannelIO();

    // Boot ChannelIO
    window.ChannelIO('boot', {
      "pluginKey": "d29f0b19-ded0-44b5-a043-2b02b299920e"
    });

    // Cleanup on component unmount
    return () => {
      if (window.ChannelIO) {
        window.ChannelIO('shutdown');
      }
    };
  }, []);

  return null; // This component doesn't render any UI
};

export default ChannelIOWidget;
